"use strict";

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Theme = require("../Theme");

var _Util = require("../Util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var types = {
  error: {
    icon: 'exclamation-circle',
    color: _Theme.colors.red,
    borderColor: '#e35b54',
    backgroundColor: 'rgba(227, 91, 84, 0.2)'
  },
  warning: {
    icon: 'exclamation-triangle',
    color: _Theme.colors.yellow,
    borderColor: '#f7d040',
    backgroundColor: 'rgba(247, 208, 64, 0.2)'
  },
  success: {
    icon: 'check-circle',
    color: _Theme.colors.green,
    borderColor: '#89ddd9',
    backgroundColor: 'rgba(137, 221, 217, 0.2)'
  },
  tip: {
    icon: 'info-circle',
    color: _Theme.colors.minor,
    borderColor: '#222222',
    backgroundColor: '#EEEEEE'
  }
};

var Alert = function Alert(props) {
  var newProps = (0, _Util.mergeProps)(props, Alert, ['style']);

  var type = newProps.type,
      children = newProps.children,
      style = newProps.style,
      className = newProps.className,
      variant = newProps.variant,
      rest = _objectWithoutProperties(newProps, ["type", "children", "style", "className", "variant"]);

  var _ref = types[type] || types.success,
      icon = _ref.icon,
      color = _ref.color,
      backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor;

  var styles = Object.assign({
    color: _Theme.colors.dark,
    backgroundColor: variant === 'border' ? backgroundColor : 'transparent',
    borderLeft: variant === 'border' ? "5px solid ".concat(borderColor) : 'none'
  }, style);
  return _react["default"].createElement(Container, Object.assign({}, rest, {
    className: "alert alert--".concat(type, " alert--").concat(variant, " ").concat(className).trim(),
    style: styles
  }), variant === 'icon' && _react["default"].createElement(_Icon["default"], {
    className: "alert-icon",
    name: icon,
    size: 24,
    style: {
      color: color
    }
  }), _react["default"].createElement(_Typography["default"], {
    component: "div",
    className: "alert-content"
  }, children));
};

Alert.propTypes = {
  type: _propTypes["default"].oneOf(Object.keys(types)),
  children: _propTypes["default"].any.isRequired,
  className: _propTypes["default"].string,
  style: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  variant: _propTypes["default"].oneOf(['border', 'icon'])
};
Alert.defaultProps = {
  type: 'tip',
  className: '',
  style: '{}',
  variant: 'border'
};
var _default = Alert;
exports["default"] = _default;

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Alert__Container",
  componentId: "sc-49s8s4-0"
})(["display:flex;align-items:center;font-size:16px;margin:0;padding:16px;margin:16px 0;strong{margin:0 5px;}.alert-icon{margin-right:16px;}.alert-content{flex:1;display:flex;flex-direction:column;}"]);